// extracted by mini-css-extract-plugin
export var accordionDetails = "index-module--accordionDetails--2fba2";
export var accordionItem = "index-module--accordionItem--dcb32";
export var accordionItemChildren = "index-module--accordionItemChildren--78cb6";
export var accordionItemContent = "index-module--accordionItemContent--e1c38";
export var accordionItemTitle = "index-module--accordionItemTitle--2692c";
export var accordionItemTitleOrange = "index-module--accordionItemTitleOrange--10f8f";
export var accordionItemTitlePrimary = "index-module--accordionItemTitlePrimary--2edd6";
export var accordionItemTitleVerbose = "index-module--accordionItemTitleVerbose--40f06";
export var small = "index-module--small--60153";